module.exports = __webpack_public_path__ + "statics/img/cate6-3@2x.225eb04d.png";